module.exports = __webpack_public_path__ + "img/plans-and-prices.8b48312b.webp";